import React, {PureComponent} from 'react';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {connect} from 'react-redux';

import LazyLoad from '../lazy-image/react-lazyload/index';
import {itemType, itemProps, itemTypes} from '../structured-data/structuredData';
import CardDescription from './CardDescription';
import CardPrice from './CardPrice';
import StarRating from '@homeaway/react-star-rating-svg';
import {getValue, TESTS} from '../../../utils/abacus';
import {InstantBookableSVG} from '../listings/InstantBookableSVG';

function imageLoaded() {}

function placeholderImage(altText) {
    return (<div className={'placeholder'} alt={altText} />);
}

export function mapStateToProps({abacus}) {
    return {abacus};
}

function listingCaption(abacus, propertyType, toplineDescription) {
    const props = {
        className: 'Card__caption',
        'data-slot': 'caption'
    };

    const description = (<CardDescription text={toplineDescription} />);

    return propertyType
        && getValue(abacus, TESTS.PROPERTY_NAME_IN_LISTING_CARD) === 1
        ? <div {...props}>
            <h4 className={'GreatPlaceRatioCard__title'}>{propertyType}</h4>
            <h5 className={'GreatPlaceRatioCard__subtitle'}>{description}</h5>
        </div>
        : <h4 {...props}>{description}</h4>;
}

export class GreatPlacesRatioCardComponent extends PureComponent {
    render() {
        const {
            abacus,
            aspectRatio = '4x3',
            link,
            highlighted,
            horizontalScrollContainer = '',
            imageSrc,
            instantBookable,
            onClick,
            onMouseOut,
            onMouseOver,
            position,
            price,
            propertyName,
            propertyType,
            review,
            seoLink,
            toplineDescription
        } = this.props;

        const className = highlighted ? 'GreatPlaceRatioCard GreatPlaceRatioCard--highlighted' : 'GreatPlaceRatioCard';

        const placeholder = placeholderImage('');

        const caption = listingCaption(abacus, propertyType, toplineDescription);

        return (
            <a href={link} onClick={onClick} className={className} onMouseOver={onMouseOver}
                onMouseOut={onMouseOut} {...itemTypes(['Product', 'ListItem'], 'itemListElement')}
            >
                {itemProps({
                    image: imageSrc,
                    name: propertyName,
                    url: seoLink,
                    position: position + 1
                })}
                <AspectRatioCard aspectRatio={aspectRatio} key={imageSrc} >
                    <div data-slot={'figure'} className={'GreatPlaceRatioCard__img-container'} onLoad={imageLoaded}>
                        <LazyLoad once offset={200} placeholder={placeholder} addListener={horizontalScrollContainer}>
                            <img src={imageSrc} alt={propertyName} />
                        </LazyLoad>
                    </div>
                    {caption}
                    <div data-slot={'content'} className={'GreatPlaceRatioCard__footer'}>
                        {instantBookable ? <InstantBookableSVG svgTitle={instantBookable}/> : null}
                        <CardPrice price={price}/>
                        <div className={'GreatPlaceRatioCard__review'}>
                            <StarRating review={review} />
                            {review.reviewCount ? <span className={'GreatPlaceRatioCard__footer__reviewcount'}>({review.reviewCount})</span> : null}
                        </div>
                        <span {...itemType('AggregateRating', 'aggregateRating')}>
                            {itemProps({
                                ratingValue: review.averageRating,
                                reviewCount: review.reviewCount
                            })}
                        </span>
                    </div>
                </AspectRatioCard>
            </a>
        );
    }
}

export const GreatPlacesRatioCard =
    connect(mapStateToProps)(GreatPlacesRatioCardComponent);
export default GreatPlacesRatioCard;

